import Http from "@/commons/Http";

const path = 'api/custa-aninhada';

export default {

    async listar(protocoloId) {
        return Http.get(`${path}/${protocoloId}/listar`);
    },

    async agrupar(protocoloId, paiTipo, paiId, filhos) {
        return Http.post(`${path}/${protocoloId}`, {
            paiTipo,
            paiId,
            filhos
        });
    },

    async desvincularFilho(id) {
        return Http.delete(`${path}/desvincular/${id}`);
    },

    async desvincularGrupo(tipo, paiId) {
        return Http.delete(`${path}/grupo/${tipo}/${paiId}`);
    }
}
